export default __webpack_public_path__ + "static/media/airtime.55786b82.svg";